/* At-a-glance feature grid: balanced rows where `flex-wrap: balance` is not supported.
 *
 * The grid is a flex row of fixed 104px cells (section-main-product-v2.css, "Spacing pass, round
 * two"). `flex-wrap: balance` -- when the browser has it -- spreads N cells over the rows a plain
 * wrap would need so no row is left with a straggler (five cells: 3 + 2, not 4 + 1). This file is
 * the fallback for browsers that do not: it reproduces the balance by capping the grid's width so
 * only ceil(N / rows) cells fit a row, and lets the plain `flex-wrap: wrap` do the rest. It exits
 * immediately where the property is supported, so it never fights the native layout.
 *
 * Width-driven, not count-driven, on purpose: how many cells fit a row depends on the column, and
 * the column is 490 at 1728 but 654 at 834. The mobile grid is a CSS grid (display: grid), which
 * the `display` check below leaves alone.
 */
(() => {
  if (window.CSS && CSS.supports && CSS.supports('flex-wrap', 'balance')) return;
  const GRID = '.pdp-v2__glance-grid';

  const balance = (grid) => {
    grid.style.maxWidth = '';
    const cs = getComputedStyle(grid);
    if (cs.display !== 'flex') return;
    const items = [...grid.children].filter((el) => el.getBoundingClientRect().width > 0);
    const n = items.length;
    if (n < 2) return;
    const padL = parseFloat(cs.paddingLeft) || 0;
    const padR = parseFloat(cs.paddingRight) || 0;
    const gap = parseFloat(cs.columnGap) || 0;
    const inner = grid.getBoundingClientRect().width - padL - padR;
    const cell = items[0].getBoundingClientRect().width;
    const perRow = Math.max(1, Math.floor((inner + gap) / (cell + gap)));
    if (n <= perRow) return;
    const rows = Math.ceil(n / perRow);
    const per = Math.ceil(n / rows);
    if (per === perRow) return;
    // Border-box (Dawn's `html { box-sizing: border-box }` inherits everywhere), so the paddings
    // belong inside the cap.
    grid.style.maxWidth = `${per * cell + (per - 1) * gap + padL + padR}px`;
  };

  const run = () => document.querySelectorAll(GRID).forEach(balance);
  run();
  if ('ResizeObserver' in window) {
    // Observe the card, not the grid: capping the grid's own width must not re-trigger itself.
    const ro = new ResizeObserver(run);
    document.querySelectorAll(GRID).forEach((g) => g.parentElement && ro.observe(g.parentElement));
  } else {
    addEventListener('resize', run);
  }
  document.addEventListener('shopify:section:load', run);
})();
